import { useSelector } from 'react-redux';

import { getCoreRentalIsEligibleForExtension, getCoreRentalMission } from '../selectors/coreApi';

import { MISSION_STATUS } from '../enums';
import { isCoveredForRentalExtension } from '../utils/coreApi';

export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export function useRentalExtensionAvailable(rentalDropOffTime) {
  const rentalMission = useSelector(getCoreRentalMission);
  const isEligibleForExtension = useSelector(getCoreRentalIsEligibleForExtension);
  const selectedIsCoveredForExtension = useSelector(isCoveredForRentalExtension);

  const isStarted = rentalMission?.status === MISSION_STATUS.STARTED;

  const isWithinRentalWindow = rentalDropOffTime !== null && Date.now() < rentalDropOffTime;

  const isAcceptedAndOld =
    rentalMission?.status === MISSION_STATUS.ACCEPTED &&
    // eslint-disable-next-line eqeqeq
    rentalMission.requestAcceptedTimestamp != null &&
    Date.now() - Date.parse(rentalMission.requestAcceptedTimestamp) > ONE_DAY_IN_MILLISECONDS;

  return isEligibleForExtension !== false && selectedIsCoveredForExtension && isWithinRentalWindow && (isStarted || isAcceptedAndOld);
}
